import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'chart-cohort', 'ChartCohort', [["path",{"d":"M3 9h18v-6h-18v18h6v-18"}],["path",{"d":"M3 15h12v-12"}]]);